export default {
  path: 'login',
  name: 'Login',
  component: () => import(/* webpackChunkName: "Login" */ '@/app/auth/login/LoginContainer.vue'),
  meta: {
    title: 'TV24 | logowanie',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
